import React, { Component, useEffect, useState, useContext } from "react";
import "./home.css";
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import { Container, Grid } from "@mui/material/";

//appbar stuff
import "../../components/topbar/topbar.css";

import AdminArea from "../../components/adminArea/AdminArea";
import ClientPositionArea from "../../components/clientPositionArea/ClientPositionArea";

import ResponsiveAppBar from "../../components/navbar/responsiveAppBar";
import DataContext from "../../context/DataContext";
import AuthContext from "../../context/AuthContext";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
// import AntSwitch from "../../components/AntSwitch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Divider } from "@mui/material";

import Title from "../../components/Title";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

export default function Home() {
  let { setClientChecked, clientChecked, clientName } = useContext(DataContext);
  let { isAdmin, setIsAdmin, viewAsAdmin, setViewAsAdmin } =
    useContext(AuthContext);

  useEffect(() => {
  }, []);
  const handleChange = () => {
    setIsAdmin(!isAdmin);
  };

  return (
    <Grid>
      <ResponsiveAppBar />

      <Grid
        component="main"
        sx={{
          // flexGrow: 1,
          py: 4,
          // height: "100vh",
          overflow: "auto",
          backgroundColor: "#FBFBFB",
        }}
      >
        <Container maxWidth={"lg"}>
          <Grid container rowSpacing={2}>
            {/* DEMO ONLY CARD VIEW */}
            <Grid item>
              <Card sx={{ p: 1, border: 1 }}>
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend">
                    <b>Demo Only:</b> Choose admin or user view
                  </FormLabel>
                  <FormGroup>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>Admin</Typography>
                      <AntSwitch
                        checked={!isAdmin}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "ant design" }}
                      />
                      <Typography>User Client</Typography>
                    </Stack>
                  </FormGroup>
                </FormControl>
              </Card>
            </Grid>

            {isAdmin && (
              <Grid item sx={{ pb: 2 }} rowSpacing={2}>
                <Typography color="#757575" variant="h4" sx={{ m: 2 }}>
                  Admin Dashboard
                </Typography>
                <AdminArea />
                <Divider sx={{ mt: 4, background: "#757575" }} />
              </Grid>
            )}
            <Grid item>
              <ClientPositionArea />
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </Grid>
  );
}
